module.exports = __webpack_public_path__ + "img/248.2a4f3801.png";